export default __webpack_public_path__ + "static/Group 630-63e41e3e10f505363d040316086fffc6.png";